import {
	GitHub,
	LinkedIn,
	FacebookRounded,
	Instagram
} from "@mui/icons-material";

export const socialMediaData = [
	{
		id: 1,
		icon: GitHub,
		color: "#000000",
		url: "https://github.com/jahid6597"
	},
	{
		id: 2,
		icon: LinkedIn,
		color: "#0a66c2",
		url: "https://www.linkedin.com/in/jahid6597"
	},
	{
		id: 3,
		icon: FacebookRounded,
		color: "#1877f2",
		url: "https://www.facebook.com/Jahid6597"
	},
	{
		id: 4,
		icon: Instagram,
		color: "#e03189",
		url: "https://www.instagram.com/jahid5151"
	}
];
